import { Box, Stack } from '@mui/material';
import React, { useEffect } from 'react';
import ReactSelect from 'components/common/react-select/ReactSelect';
import { FormComponentValue } from 'components/common/form/layout/control';
import { AlertRuleScreenProps } from 'components/alert-rule-popup/index';
import { useTranslation } from 'react-i18next';

interface AlertRuleMethodProps extends AlertRuleScreenProps {
    onChange?: (text: any) => void;
}

export default function AlertRuleMethod(props: AlertRuleMethodProps) {
    const { alertRuleData, wizardData, updateAlertRuleData = () => {}, onChange = () => {} } = props;

    const { t } = useTranslation(['components/alert-rule-popup/alert_rule_popup']);

    const select_immediate_notification_ind: FormComponentValue[] = Object.keys(
        wizardData.form.immediate_notification_ind.data,
    ).map((key: string) => {
        return {
            label: t('form.method.immediate_notification_ind.' + key),
            value: key,
        };
    });

    const select_send_notification_via: FormComponentValue[] = Object.keys(
        wizardData.form.send_notification_via.data,
    ).map((key: string) => {
        return {
            label: t('form.method.send_notification_via.' + key),
            value: key,
        };
    });

    const select_trigger_alert_when: FormComponentValue[] = Object.keys(wizardData.form.trigger_alert_when.data).map(
        (key: string) => {
            return {
                label: t('form.method.trigger_alert_when.' + key.replaceAll(' ', '_')),
                value: key,
            };
        },
    );

    useEffect(() => {
        let html = [];

        const translationData = {
            markTagSTART: '<span class="mark">',
            markTagEND: '</span>',
            methodName: t('form.method.send_notification_via.' + alertRuleData.send_notification_via),
        };

        switch (alertRuleData.immediate_notification_ind) {
            case 'Y':
                html = ['send_immediately'];
                break;
            case 'None':
                html = ['send_browser'];
                break;
            default:
                html = ['send_email'];
        }

        if (alertRuleData.trigger_alert_when === 'first time only') {
            html.push('when_first_time_only');
        } else {
            html.push('when_every_time');
        }

        onChange(
            html
                .map((trans_key) => {
                    return t(`description_rule.method.${trans_key}`, translationData);
                })
                .join(' ') + '.',
        );
    }, [
        alertRuleData.immediate_notification_ind,
        alertRuleData.send_notification_via,
        alertRuleData.trigger_alert_when,
    ]);

    const sendImmediately = alertRuleData.immediate_notification_ind === 'Y';

    if (Number(alertRuleData.workflow_id) > 0) return <Box>{t('form.method.workflow_step_4')}</Box>;

    return (
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
            <Box component={'span'} sx={{ my: '4px !important' }}>
                {sendImmediately
                    ? t('form.method.immediate_notification_label')
                    : t('form.method.not_immediate_notification_label')}
            </Box>
            <Box sx={{ display: 'inline-flex', my: '4px !important' }}>
                <ReactSelect
                    dataTest={'ar-immediate-notification-ind'}
                    data={select_immediate_notification_ind}
                    value={[alertRuleData.immediate_notification_ind]}
                    update={(newVal) => {
                        updateAlertRuleData({
                            immediate_notification_ind: newVal,
                        });
                    }}
                />
            </Box>
            {sendImmediately && (
                <Box sx={{ display: 'inline-flex', my: '4px !important' }}>
                    <ReactSelect
                        dataTest={'ar-send-notification-via'}
                        data={select_send_notification_via}
                        value={[alertRuleData.send_notification_via]}
                        update={(newVal) => {
                            updateAlertRuleData({
                                send_notification_via: newVal,
                            });
                        }}
                    />
                </Box>
            )}
            <Box sx={{ display: 'inline-flex', my: '4px !important' }}>
                <ReactSelect
                    dataTest={'ar-trigger-alert-when'}
                    data={select_trigger_alert_when}
                    value={[alertRuleData.trigger_alert_when]}
                    update={(newVal) => {
                        updateAlertRuleData({
                            trigger_alert_when: newVal,
                        });
                    }}
                />
            </Box>
        </Stack>
    );
}
